export function Spinner() {
  return (
    <div className="spinner m-0.5 h-16 w-16">
      <svg viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="20" />
      </svg>
    </div>
  );
}
